import { render } from "./SaveEmergencyContact.vue?vue&type=template&id=1fec1389"
import script from "./SaveEmergencyContact.vue?vue&type=script&lang=js"
export * from "./SaveEmergencyContact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__